module.exports = __webpack_public_path__ + "media/box_anim_s.604e08ef.mp3";